var _regeneratorRuntime = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/richard/status/chat/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var PeerInfo = require('peer-info');

var PeerId = require('peer-id');

var LibP2PBundle = require('./libp2p-bundle');

var chalk = require('chalk');

var pull = require('pull-stream');

var drain = require('pull-stream/sinks/drain');

var rlp = require('rlp-encoding');

var Events = require('events');

var config = require('../data/config.json');

var _require = require('./shh.js'),
    SHH_BLOOM = _require.SHH_BLOOM,
    SHH_MESSAGE = _require.SHH_MESSAGE,
    SHH_STATUS = _require.SHH_STATUS;

var Envelope = require('./envelope');

var p2pNode;

var libP2Phello = function libP2Phello(eventEmitter) {
  return function (err) {
    if (err) {
      throw err;
    }

    console.log(chalk.yellow("* libP2P started: ".concat(p2pNode.isStarted(), ", listening on:")));
    p2pNode.peerInfo.multiaddrs.forEach(function (ma) {
      return console.log(chalk.yellow("- " + ma.toString()));
    });
    eventEmitter.emit('ready');
  };
};

var createNode = function createNode(self) {
  return new Promise(function (resolve, reject) {
    var nodeHandler = function nodeHandler(err, peerInfo) {
      if (err) {
        reject(err);
      }

      p2pNode = new LibP2PBundle(peerInfo, {
        startWRTC: !self.isBrowser,
        signalServers: self.signalServers,
        bootnodes: self.bootnodes
      });
      p2pNode.old_start = p2pNode.start;

      p2pNode.start = function () {
        p2pNode.old_start(libP2Phello(self.events));
      };

      p2pNode.handle('/ethereum/shh/6.0.0/dev-v1', function (protocol, conn) {
        pull(conn, pull.map(function (v) {
          return rlp.decode(Buffer.from(v.toString(), 'hex'));
        }), drain(function (message) {
          conn.getPeerInfo(function (err, peerInfo) {
            try {
              var code = message[0].readUInt8(0);
              var payload = rlp.decode(message[1]);
              var peerId = peerInfo.id.toB58String();
              if (code === SHH_STATUS) p2pNode.emit('status', payload, peerId);
              if (code === SHH_BLOOM) p2pNode.emit('bloom_exchange', payload, peerId);

              if (code === SHH_MESSAGE) {
                payload.forEach(function (envelope) {
                  p2pNode.emit('message', new Envelope(envelope), peerId);
                });
              }
            } catch (e) {
              console.log("Invalid message: " + e.message);
            }
          });
        }));
      });
      resolve(p2pNode);
    }; // TODO: probably not secure and prone to errors. Fix
    //       also, what's the diff between createFromHexString and createFromPrivKey?


    var privateKey = self.privateKey ? Buffer.from(self.privateKey, "hex") : null;

    if (privateKey) {
      var peerId = PeerId.createFromHexString(privateKey);
      PeerInfo.create(peerId, nodeHandler);
    } else {
      PeerInfo.create(nodeHandler);
    }
  });
};

var LibP2PNode =
/*#__PURE__*/
function () {
  "use strict";

  function LibP2PNode(options) {
    _classCallCheck(this, LibP2PNode);

    if (!options) options = {};
    this.privateKey = options.privateKey;
    this.bootnodes = options.bootnodes || [];
    this.staticnodes = options.staticnodes || [];
    this.trustedPeers = [];
    this.events = new Events();
    this.peers = {};
    this.type = "libp2p"; // Candidates for DI

    this.tracker = null;
    this.bloomManager = null;
    this.isBrowser = options.isBrowser || false;
    this.signalServers = options.signalServers || [];
  }

  _createClass(LibP2PNode, [{
    key: "setConfig",
    value: function setConfig(config) {
      this.bootnodes = config.bootnodes;
      this.privateKey = config.account ? Buffer.from(config.account, "hex") : null;
    }
  }, {
    key: "setTracker",
    value: function setTracker(tracker) {
      this.tracker = tracker;
    }
  }, {
    key: "setBloomManager",
    value: function setBloomManager(bloomManager) {
      var _this = this;

      this.bloomManager = bloomManager;
      this.bloomManager.on('updated', function () {
        _this.broadcast(_this.bloomManager.getBloomFilter(), null, SHH_BLOOM);
      });
    }
  }, {
    key: "start",
    value: function () {
      var _start = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return createNode(this);

              case 2:
                this.node = _context.sent;
                this.node.start();

                this._startDiscovery();

                this._processMessages();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }()
  }, {
    key: "_startDiscovery",
    value: function _startDiscovery() {
      var _this2 = this;

      this.node.on('peer:discovery', function (peer) {
        // console.log('Discovered:', peer.id.toB58String());
        _this2.node.dial(peer, function () {});
      });
      this.node.on('peer:connect', function (peer) {
        console.log(chalk.green("Add libp2p peer: ".concat(peer.id.toB58String())));
        _this2.peers[peer.id.toB58String()] = {
          peer: peer
        }; // Sending the status on initial connection

        var payload = [Buffer.from([6]), Buffer.from("3f50624dd2f1a9fc", "hex"), _this2.bloomManager.getBloomFilter(), Buffer.from([]), Buffer.from([1])];

        _this2.broadcast(payload, peer.id.toB58String(), SHH_STATUS);
      });
      this.node.on('peer:disconnect', function (peer) {
        delete _this2.peers[peer.id.toB58String()];
        console.error(chalk.red("Peer disconnected - (".concat(peer.id.toB58String())));
      });
    }
  }, {
    key: "_processMessages",
    value: function _processMessages() {
      var _this3 = this;

      this.node.on('message', function (envelope, peer) {
        if (_this3.tracker.exists(envelope, 'libp2p')) return; // Verify if message matches bloom filter

        if (!_this3.bloomManager.match(envelope.bloom)) return; // TODO: for mailservers, inspect peer
        // Verifying if old message is sent by trusted peer by inspecting peerInfo.multiaddrs

        /*if(self.isTooOld(message.expiry) && !PEER_IS_TRUSTED){
          // console.log("Discarting old envelope");
          return;
        }*/

        _this3.tracker.push(envelope, 'libp2p'); // Broadcast received message again.


        _this3.broadcast(envelope);

        _this3.events.emit('shh_message', envelope);
      });
      this.node.on("status", function (status, peerId) {
        _this3.peers[peerId].bloom = status[2];
      });
      this.node.on("bloom_exchange", function (bloom, peerId) {
        _this3.peers[peerId].bloom = bloom;
      });
    }
  }, {
    key: "broadcast",
    value: function broadcast(input, peerId) {
      var code = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : SHH_MESSAGE;
      var message = rlp.encode(input instanceof Envelope ? [input.message] : input);
      if (code === null) code = SHH_MESSAGE;

      var cb = function cb(code, msg) {
        return function (err, conn) {
          code = Buffer.from([code]);
          var payload = rlp.encode([code, msg]);
          if (!err) pull(pull.values([payload.toString('hex')]), conn);
        };
      };

      if (peerId) {
        var peer = this.peers[peerId].peer;
        this.node.dialProtocol(peer, '/ethereum/shh/6.0.0/dev-v1', cb(code, message));
      } else {
        var _arr = Object.keys(this.peers);

        for (var _i = 0; _i < _arr.length; _i++) {
          var _peerId = _arr[_i];
          var p = this.peers[_peerId];
          if (code == SHH_MESSAGE && !this.bloomManager.filtersMatch(p.bloom, input.bloom)) continue;
          this.node.dialProtocol(p.peer, '/ethereum/shh/6.0.0/dev-v1', cb(code, message));
        }
      }
    }
  }, {
    key: "addTrustedPeer",
    value: function addTrustedPeer(node) {
      this.trustedPeers.push(node);
    }
  }, {
    key: "isTooOld",
    value: function isTooOld(expiry) {
      var dt = new Date().getTime() / 1000;
      return expiry.readUInt32BE(0) < dt;
    }
  }]);

  return LibP2PNode;
}();

module.exports = LibP2PNode;